import React from "react";
import Filter, { FilterProps } from "elements/Filter/Filter";
import { hasValue } from "utilities/filters/filters";
import { SortState } from "store/filters";
import { useQueryParamObjectWith } from "polyrouter";
import { AllQueryParam } from "polyrouter/allQueryParams";
import { keyIter } from "utilities/objectUtils";
import {
  LinkedState,
  ProvisioningState
} from "elements/ConnectionStatusIndicator/ConnectionStatusIndicator";

export type DeviceFilterState = {
  model?: string;
  version?: string;
  connected?: "false" | "true";
  insight?: string;
  site?: string;
  sort?: SortState;
  status?: string;
  linkedDeviceState?: LinkedState;
  provisioningState?: ProvisioningState;
  entitledUntilDate?: string;
};

export const defaultFilterState: DeviceFilterState = {
  model: undefined,
  version: undefined,
  insight: undefined,
  connected: undefined,
  site: undefined,
  sort: {
    field: "model",
    direction: "ASC"
  },
  status: undefined,
  provisioningState: undefined,
  linkedDeviceState: undefined
};

export const areFiltersSelected = (
  filterValues: DeviceFilterState
): boolean => {
  let filtersSelected = false;
  keyIter(defaultFilterState).forEach(key => {
    if (key !== "sort" && hasValue(filterValues, key)) {
      filtersSelected = true;
    }
  });

  return filtersSelected;
};

export function useDeviceFilterValue() {
  return useQueryParamObjectWith<AllQueryParam, DeviceFilterState>(
    "DeviceFilterState",
    defaultFilterState
  );
}

export const DeviceFilter = (props: FilterProps<DeviceFilterState>) => (
  <Filter {...props} />
);
